import { render, staticRenderFns } from "./FormulaQna.vue?vue&type=template&id=6e5c9f42"
import script from "./FormulaQna.vue?vue&type=script&lang=js"
export * from "./FormulaQna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports